import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { NewScarcityIcon } from '@sorare/core/src/atoms/icons/ScarcityIcon';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { glossary } from '@sorare/core/src/lib/glossary';

import { BuyingPlayerDetailsFooter_anyPlayer } from './__generated__/index.graphql';

const Root = styled(Horizontal).attrs({ gap: 2 })`
  justify-content: center;
`;

type Props = {
  anyPlayer: BuyingPlayerDetailsFooter_anyPlayer;
  rarity: Rarity;
  inSeason: boolean;
  onMarketClick: (playerSlug: string) => void;
};

export const BuyingPlayerDetailsFooter = ({
  anyPlayer,
  rarity,
  onMarketClick,
}: Props) => {
  const { slug } = anyPlayer;
  return (
    <Root>
      <Button
        fullWidth
        color="secondary"
        size="medium"
        role="link"
        startIcon={<NewScarcityIcon rarity={rarity} size={2} />}
        onClick={() => onMarketClick(slug)}
      >
        <FormattedMessage {...glossary.listings} />
      </Button>
    </Root>
  );
};

BuyingPlayerDetailsFooter.fragments = {
  anyPlayer: gql`
    fragment BuyingPlayerDetailsFooter_anyPlayer on AnyPlayerInterface {
      slug
    }
  ` as TypedDocumentNode<BuyingPlayerDetailsFooter_anyPlayer>,
};
